export const POLL_UPDATE: string = 'pollUpdate';
export const POLL_COMPLETED: string = 'pollCompleted';
export const ACTIVE_ORDER_UPDATED: string = 'activeOrderUpdated';

// NEW ORDER PROMPT
export const ETA_PROMPT: string = 'etaPrompt';

// FILTER/DISPLAY CHANGES
export const FILTER_CHANGED: string = 'filterChanged';
export const SORT_CHANGED: string = 'sortChanged';
export const APP_DOCKET_DISPLAY_UPDATE: string = 'appDisplayUpdate';
export const ORDER_COUNT_CHANGED: string = 'orderCountChanged';

// GLOBAL SCALE UPDATES
export const ACTIVE_BUMP_SCREEN_CHANGED: string = 'activeBumpScreenChanged';
export const SERVER_CHANGED: string = 'serverChanged';

// SETTINGS
export const GLOBAL_SETTINGS_LOADED: string = 'globalSettingsLoaded';
export const APP_SETTINGS_CHANGED: string = 'appSettingsChanged';

// NOTIFICATIONS
export const NOTIFICATIONS_UPDATE: string = 'notificationsUpdate';
export const PLAY_SOUND_ETA: string = 'playSoundETA';
export const PLAY_SOUND_NEW: string = 'playSoundNewOrder';

// AUTO PRINTING
export const AUTO_PRINTING_ORDER: string = 'autoPrintingOrder';
export const AUTO_ETA_PRINTING_ORDER: string = 'autoETAPrintingOrder';
export const AUTO_PRINTING_COMPLETE: string = 'autoPrintingOrderComplete';

// PRINTER
export const ACTIVE_PRINTERS_CHANGED: string = 'activePrinterChanged';
export const SETTING_ACTIVE_PRINTER: string = 'settingActivePrinter';
export const PRINTER_STATUS_CHECK_COMPLETED: string = 'printerStatusCheckCompleted';
export const PRINTER_STATUS_PING: string = 'printerStatusPingRequired';
export const NEW_DOCKET_TO_PRINT: string = 'newDocketToPrint';

// AUTHENTICATION
export const LOG_IN: string = 'userLogIn';
export const LOG_OUT: string = 'userLogOut';

// APP LOADED
export const APP_LOADED: string = 'appLoaded';

// CLOCK
export const CLOCK_TICK: string = 'clockTick';
export const DAY_CHANGED: string = 'dayChanged';

// OPENING HOURS
export const NEW_OPENING_HOURS: string = 'newOpeningHours';

// OPEN INAPP BROWSER
export const OPEN_URL_BROWSER: string = 'openURLBrowser';

// PIN
export const PIN_ADDED: string = 'pinAdded';
export const PIN_REMOVED: string = 'pinRemoved';

// MESSAGE BOARD
export const VIEW_MESSAGE_BOARD_ITEM: string = 'viewMessageBoardItem';
